import { forwardRef } from 'react';

import { Switch as MuiSwitch, SwitchProps as MuiSwitchProps } from '@mui/material';

export type SwitchProps = Pick<
  MuiSwitchProps,
  | 'aria-label'
  // Added for the visual refresh. The DS switch names itself from `label` / `aria-label` /
  // `aria-labelledby`, and `aria-labelledby` is the one the design's own settings rows use — the row
  // heading IS the control's name, so pointing at it beats duplicating it into an `aria-label` and
  // having a screen reader announce the setting twice. `SwitchBox` needs it for a second reason: it
  // associates its external label with `htmlFor`, which binds only to labelable elements, and Base
  // UI puts the id on a non-labelable root.
  | 'aria-labelledby'
  | 'checked'
  | 'defaultChecked'
  | 'disabled'
  | 'id'
  | 'name'
  | 'size'
  | 'onChange'
  | 'value'
  | 'sx'
>;

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => <MuiSwitch ref={ref} {...props} />);
